export const isInteractiveEventTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;

  return Boolean(
    target.closest('button') ||
      target.closest('a') ||
      target.closest('input') ||
      target.closest('textarea') ||
      target.closest('select') ||
      target.closest('label') ||
      target.closest('[role="button"]') ||
      target.closest('[role="listbox"]') ||
      target.closest('[role="dialog"]') ||
      target.closest('[role="menuitem"]') ||
      target.closest('[data-interactive="true"]'),
  );
};
